import { CppService } from './../../../services/cpp/cpp.service';
import { CommonService } from './../../../services/common/common.service';
import { Component, OnInit, ViewChild, OnChanges, SimpleChanges, OnDestroy, } from '@angular/core';
import { QuoteOrderService } from '../../../services/quote-order/quote-order.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { Sort, MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { ExcelService } from '../../../services/infrastructure/excel.service';
import { MasterConstants } from '../../../common/constants/master-constants';

@Component({
  selector: 'app-view-quote-order',
  templateUrl: './view-quote-order.component.html',
  styleUrls: ['./view-quote-order.component.scss']
})
export class ViewQuoteOrderComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();

  quoteId: number;
  quoteNumber: string;
  quoteDetail: any;
  quoteItemList: any;
  displayedHeaderTableCol: string[] = ['account', 'status', 'quoteDate', 'closeDate', 'preparedBy', 'preparedFor'];

  searchTypeList: string[] = [];
  selectedValue: string;
  orderFilters: any;
  filter: any;
  filterValueList = new Array();
  itemNumberList: any = [];
  fromRequestedDeliveryDateFilter: any;
  toRequestedDeliveryDateFilter: any;
  selectedCount = 0;
  filteredDataCount = 0;
  searchValue = '';
  plAccess = false;

  public viewQuoteOrderDS: MatTableDataSource<any>;
  filterQuoteOrderDSitems: any[] = [];
  displayedColumns: string[];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private quoteOrderService: QuoteOrderService,
    private router: Router,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private datePipe: DatePipe,
    private commonService: CommonService,
    private cppService: CppService,
    private excelService: ExcelService) { }

  ngOnInit() {
    this.viewQuoteOrderDS = new MatTableDataSource([]);
    this.viewQuoteOrderDS.paginator = this.paginator;
    this.viewQuoteOrderDS.sort = this.sort;

    this.subscription.push(this.quoteOrderService.quoteId.subscribe(x => {
      if (x && x != 0) {
        this.quoteId = x;
        this.getViewQuoteOrders();
        this.displayedColumns = ['orderNumber', 'shipTo', 'custPO', 'product', 'uom', 'shipQty', 'priceUOM', 'qtyPriced', 'packageSize', 'requestedDeliveryDate'];
        this.setSearchTypeList();
        this.resetPageFilter();
      }
    }));

    // Get Item Numbers

    this.subscription.push(this.cppService.getCppItemNumberList().subscribe((result: any[]) => {
      this.itemNumberList = result;
    }));

    if (this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST)) {
      this.plAccess = true;
      this.displayedColumns = ['orderNumber', 'shipTo', 'custPO', 'product', 'uom', 'shipQty', 'unitPrice', 'priceUOM', 'qtyPriced', 'totalPrice', 'packageSize', 'requestedDeliveryDate'];
    }
  }

  // Get data for view quote orders
  getViewQuoteOrders() {
    this.loaderService.setLoaderStatus(true);

    this.subscription.push(this.quoteOrderService.getQuoteOrder(this.quoteId).subscribe(result => {
      this.quoteDetail = new Array(result);
      this.quoteItemList = result.quoteItems;
      this.quoteNumber = result.quoteNumber;

      this.viewQuoteOrderDS = new MatTableDataSource(result.quoteItems);
      this.viewQuoteOrderDS.paginator = this.paginator;
      this.paginator.firstPage();
      this.viewQuoteOrderDS.sort = this.sort;
      this.loaderService.setLoaderStatus(false);
      this.bindDataSource(result.quoteItems, true);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Back to Landing page
  backToLandingPage() {
    this.router.navigate(['/cpp/landing-data']);
    this.commonService.currentTabIndex.next(2);
  }

  // Back to Quote
  backToQuote() {
    this.router.navigate(['/quote/view-quote-details/' + this.quoteNumber]);
  }

  // Export Quote Orders
  exportQuoteOrders() {
    const exportData = [];
    this.loaderService.setLoaderStatus(true);
    if (this.quoteItemList && this.quoteItemList.length > 0) {
      if (this.plAccess) {
        this.quoteItemList.forEach(x => {
          exportData.push({
            'Order Number': x.orderNumber,
            'Shipto/Deliver To Account Number': x.accountNumber,
            'Shipto/Deliver To Name': x.shipTo,
            'Shipto/Deliver To Address': x.address,
            'Shipto/Deliver To City': x.city,
            'Shipto/Deliver To State': x.state,
            'Shipto/Deliver To Zip Code': x.zipCode,
            'PO #': x.custPO,
            'Product': x.product,
            'UOM': x.uom,
            'Ship Qty': x.shipQty,
            'Unit Price ': x.unitPrice?.toFixed(4) ?? "",
            'Price UOM ': x.priceUOM,
            'Qty Priced ': x.qtyPriced,
            'Total Price': x.totalPrice?.toFixed(4) ?? "",
            'Package Size ': x.packageSize,
            'Requested Arrival Date': this.datePipe.transform(x.requestedDeliveryDate, 'MM/dd/yyyy')
          });
        });
      } else {
        this.quoteItemList.forEach(x => {
          exportData.push({
            'Order Number': x.orderNumber,
            'Shipto/Deliver To Account Number': x.accountNumber,
            'Shipto/Deliver To Name': x.shipTo,
            'Shipto/Deliver To Address': x.address,
            'Shipto/Deliver To City': x.city,
            'Shipto/Deliver To State': x.state,
            'Shipto/Deliver To Zip Code': x.zipCode,
            'PO #': x.custPO,
            'Product': x.product,
            'UOM': x.uom,
            'Ship Qty': x.shipQty,
            'Price UOM ': x.priceUOM,
            'Qty Priced ': x.qtyPriced,
            'Package Size ': x.packageSize,
            'Requested Arrival Date': this.datePipe.transform(x.requestedDeliveryDate, 'MM/dd/yyyy')
          });
        });
      }
      this.excelService.exportAsExcelFile(exportData, 'QuoteOrders_Export');
    } else {
      this.toastrService.error('No order available for current user and filters');
    }
    this.loaderService.setLoaderStatus(false);
  }

  // Destroy
  ngOnDestroy() {
    this.quoteOrderService.setQuoteId(0);

    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // set the search filter list
  setSearchTypeList() {
    this.searchTypeList = ['Account Name', 'Account Number', 'Product Name', 'Item Number', 'Order Number', 'Customer PO#', 'Requested Arrival Date'];
    this.selectedValue = this.searchTypeList[0];
  }

  // Reset Page Filter
  resetPageFilter() {
    this.orderFilters = {
      'AccountName': null,
      'AccountNumber': null,
      'ProductName': null,
      'OrderNumber': null,
      'ItemNumber': [],
      'CustomerPO': null,
      'FromRequestedDeliveryDate': null,
      'ToRequestedDeliveryDate': null
    };

    this.filter = {
      'accountName': null,
      'accountNumber': null,
      'productName': null,
      'orderNumber': null,
      'itemNumber': [],
      'customerPO': null,
      'fromRequestedDeliveryDate': null,
      'toRequestedDeliveryDate': null
    };
  }

  // Retain Filter Value
  retainFilter(selectedObj: any, type: string, isSearch: boolean) {
    this.validateInputText();
    if (this.filterValueList) {
      let searchStr = '';

      // Create filterValueList from Product Filters
      this.filterValueList = [];

      // Set Account Name
      if (this.orderFilters.AccountName && this.orderFilters.AccountName != '') {
        this.filterValueList.push('Account Name : ' + this.orderFilters.AccountName);
        this.filter.accountName = this.orderFilters.AccountName.trim();
      } else {
        this.filter.accountName = null;
      }

      // Set Account Number
      if (this.orderFilters.AccountNumber && this.orderFilters.AccountNumber != '') {
        this.filterValueList.push('Account Number : ' + this.orderFilters.AccountNumber);
        this.filter.accountNumber = this.orderFilters.AccountNumber.trim();
      } else {
        this.filter.accountNumber = null;
      }

      // Set Product Name
      if (this.orderFilters) {
        if (this.orderFilters.ProductName && this.orderFilters.ProductName != '') {
          this.filterValueList.push('Product Name : ' + this.orderFilters.ProductName);
          this.filter.productName = this.orderFilters.ProductName.trim();
        }
      }

      // Set Item Number
      if (this.orderFilters.ItemNumber && this.orderFilters.ItemNumber.length > 0) {
        searchStr = '';
        this.orderFilters.ItemNumber.forEach(x => {
          searchStr = searchStr + x + ', ';
        });
        this.filterValueList.push('Item Number : ' + searchStr.substr(0, searchStr.length - 2));
        this.filter.itemNumber = this.orderFilters.ItemNumber;
      }
      else {
        this.filter.itemNumber = [];
      }

      // Order Number
      if (this.orderFilters.OrderNumber && this.orderFilters.OrderNumber != '') {
        this.filterValueList.push('Order Number : ' + this.orderFilters.OrderNumber);
        this.filter.orderNumber = this.orderFilters.OrderNumber.trim();
      } else {
        this.filter.orderNumber = null;
      }

      // Customer PO#
      if (this.orderFilters.CustomerPO && this.orderFilters.CustomerPO != '') {
        this.filterValueList.push('Customer PO# : ' + this.orderFilters.CustomerPO);
        this.filter.customerPO = this.orderFilters.CustomerPO.trim();
      } else {
        this.filter.customerPO = null;
      }

      // set from/to Requested Arrival Date
      if (this.orderFilters.FromRequestedDeliveryDate
        && this.orderFilters.FromRequestedDeliveryDate != null
        && this.orderFilters.ToRequestedDeliveryDate
        && this.orderFilters.ToRequestedDeliveryDate != null) {
        this.filterValueList.push('Requested Arrival Date : (' + this.datePipe.transform(this.orderFilters.FromRequestedDeliveryDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.orderFilters.ToRequestedDeliveryDate, 'MM/dd/yyyy') + ')');
        this.filter.fromRequestedDeliveryDate = new Date(this.orderFilters.FromRequestedDeliveryDate).toDateString();
        this.filter.toRequestedDeliveryDate = new Date(this.orderFilters.ToRequestedDeliveryDate).toDateString();
      }

      if (isSearch && this.orderFilters.FromOrderDate
        && this.orderFilters.FromOrderDate != null
        && this.orderFilters.ToOrderDate == null) {
        this.filterValueList.push('Order Date : (' + this.datePipe.transform(this.orderFilters.FromOrderDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(new Date(), 'MM/dd/yyyy') + ')');
        this.filter.fromOrderDate = new Date(this.orderFilters.FromOrderDate).toDateString();
        this.filter.toOrderDate = new Date().toDateString();
        this.orderFilters.ToOrderDate = new Date();
      }

      if (isSearch && this.orderFilters.FromRequestedDeliveryDate
        && this.orderFilters.FromRequestedDeliveryDate != null
        && this.orderFilters.ToRequestedDeliveryDate == null) {
        this.filterValueList.push('Requested Arrival Date : (' + this.datePipe.transform(this.orderFilters.FromRequestedDeliveryDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(new Date(), 'MM/dd/yyyy') + ')');
        this.filter.fromRequestedDeliveryDate = new Date(this.orderFilters.FromRequestedDeliveryDate).toDateString();
        this.filter.toRequestedDeliveryDate = new Date().toDateString();
        this.orderFilters.ToRequestedDeliveryDate = new Date();
      }

      if (isSearch && this.orderFilters.ToOrderDate
        && this.orderFilters.ToOrderDate != null
        && this.orderFilters.FromOrderDate == null) {
        this.filterValueList.push('Order Date : (' + this.datePipe.transform(this.orderFilters.ToOrderDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.orderFilters.ToOrderDate, 'MM/dd/yyyy') + ')');
        this.filter.fromOrderDate = new Date(this.orderFilters.ToOrderDate).toDateString();
        this.filter.toOrderDate = new Date(this.orderFilters.ToOrderDate).toDateString();
        this.orderFilters.FromOrderDate = this.orderFilters.ToOrderDate;
      }

      if (isSearch && this.orderFilters.ToRequestedDeliveryDate
        && this.orderFilters.ToRequestedDeliveryDate != null
        && this.orderFilters.FromRequestedDeliveryDate == null) {
        this.filterValueList.push('Requested Arrival Date : (' + this.datePipe.transform(this.orderFilters.ToRequestedDeliveryDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.orderFilters.ToRequestedDeliveryDate, 'MM/dd/yyyy') + ')');
        this.filter.fromRequestedDeliveryDate = new Date(this.orderFilters.ToRequestedDeliveryDate).toDateString();
        this.filter.toRequestedDeliveryDate = new Date(this.orderFilters.ToRequestedDeliveryDate).toDateString();
        this.orderFilters.FromRequestedDeliveryDate = this.orderFilters.ToRequestedDeliveryDate;
      }
    }
    this.applyFilterData(this.orderFilters);
  }

  // Filter grid data on type
  applyFilterData(filterValue: any) {
    this.filterQuoteOrderDSitems = [];
    this.viewQuoteOrderDS.filter = filterValue;
    this.selectedCount = 0;
    this.filterQuoteOrderDSitems.forEach(item => {
      if (item.isSelected) {
        this.selectedCount = this.selectedCount + 1;
      }
    });
    // this.getViewQuoteOrders()
  }

  // Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      let reqDate;
      this.viewQuoteOrderDS = new MatTableDataSource(orderList);
      this.viewQuoteOrderDS.filterPredicate = (data: any, filter: any) => {
        if (data.requestedDeliveryDate) {
          reqDate = this.datePipe.transform(data.requestedDeliveryDate, 'MM/dd/yyyy');
          data.requestedDeliveryDate = new Date(reqDate);
        }

        if ((filter.AccountName == null || (data.shipTo.toLowerCase().indexOf(filter.AccountName.toLowerCase()) > -1))
          && (filter.AccountNumber == null || (data.accountNumber.toString().indexOf(filter.AccountNumber.toLowerCase()) > -1))
          && (filter.ProductName == null || (data.product.toLowerCase().indexOf(filter.ProductName.toLowerCase()) > -1))
          && (filter.OrderNumber == null || (data.orderNumber.toLowerCase().indexOf(filter.OrderNumber.toLowerCase()) > -1))
          && (filter.ItemNumber == undefined || filter.ItemNumber.length == 0 || (filter.ItemNumber.indexOf(data.itemNumber) > -1))
          && (filter.CustomerPO == null || (data.custPO.toLowerCase().indexOf(filter.CustomerPO.toLowerCase()) > -1))
          // && (filter.FromRequestedDeliveryDate == null || (data.FromRequestedDeliveryDate.toLowerCase().indexOf(filter.FromRequestedDeliveryDate.toLowerCase()) > -1))
          // && (filter.ToRequestedDeliveryDate == null || (data.ToRequestedDeliveryDate.toLowerCase().indexOf(filter.ToRequestedDeliveryDate.toLowerCase()) > -1))
          && (filter.ToRequestedDeliveryDate == null && filter.FromRequestedDeliveryDate == null) ||
          (data.requestedDeliveryDate <= filter.ToRequestedDeliveryDate && data.requestedDeliveryDate >= filter.FromRequestedDeliveryDate)

        ) {
          this.filterQuoteOrderDSitems.push(data);
          this.filteredDataCount = this.filteredDataCount + 1;
          return true;
        }
        else {
          return false;
        }
      };
      this.applyFilterData(this.orderFilters);
    }
  }

  // Validate the search input text
  validateInputText() {
    // if (this.orderFilters.TxtAccountNo) {
    //  this.orderFilters.TxtAccountNo = this.validateNumText(this.orderFilters.TxtAccountNo);
    // }
    // if (this.orderFilters.WebOrderNumber) {
    //  this.orderFilters.WebOrderNumber = this.validateNumText(this.orderFilters.WebOrderNumber);
    // }
    // if (this.orderFilters.CustomerPONumber) {
    //  this.orderFilters.CustomerPONumber = this.validateNumText(this.orderFilters.CustomerPONumber);
    // }
  }

  // Validate number text
  validateNumText(numInput) {
    const accountRegx = RegExp('^[0-9, ]+$');
    const isValidNumInput = accountRegx.test(numInput);
    if (!isValidNumInput) {
      this.toastrService.error('Invalid Input.');
      numInput = null;
    }
    return numInput;
  }

  // Validate the Requested Arrival Date filter on search filters
  validateRequestedDeliveryDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromRequestedDeliveryDate') {
      fromDate = new Date($event.value);
      if (this.orderFilters.ToRequestedDeliveryDate) {
        var toDate = new Date(this.orderFilters.ToRequestedDeliveryDate);
        this.fromRequestedDeliveryDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toRequestedDeliveryDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toRequestedDeliveryDate') {
      toDate = new Date($event.value);
      this.fromRequestedDeliveryDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.orderFilters.FromRequestedDeliveryDate) {
        var fromDate = new Date(this.orderFilters.FromRequestedDeliveryDate);
        this.toRequestedDeliveryDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromRequestedDeliveryDateFilter = '';
      this.toRequestedDeliveryDateFilter = '';
    }
  }

  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();
    this.searchValue = '';
    this.resetPageFilter();
    this.validateRequestedDeliveryDateFilter('clearAll', '');
    this.applyFilterData(this.filter);
  }

  // Clear Filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);
      this.applyFilterData(this.filter);
    }
  }

  // To remove clear search filter
  removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Account Name':
        this.orderFilters.AccountName = null;
        break;
      case 'Account Number':
        this.orderFilters.AccountNumber = null;
        break;
      case 'Product Name':
        this.orderFilters.ProductName = null;
        break;
      case 'Order Number':
        this.orderFilters.OrderNumber = '';
        break;
      case 'Item Number':
        this.orderFilters.ItemNumber = [];
        break;
      case 'Customer PO#':
        this.orderFilters.CustPO = null;
        break;
      case 'FromRequestedDeliveryDate':
        this.orderFilters.FromRequestedDeliveryDate = null;
        break;
      case 'ToRequestedDeliveryDate':
        this.orderFilters.ToRequestedDeliveryDate = null;
        break;
      default:
        break;
    }
  }
}
